import SimpleConsentManager from './vendor/simple-consent-manager';

const lang = document.documentElement.lang.substring(0, 2);
const privacyPolicy = document.body.getAttribute('data-privacy-policy') || '/';
const matomoUrl = document.body.getAttribute('data-matomo-url');
const matomoId = document.body.getAttribute('data-matomo-id');

const imageUrl = new URL('../assets/img/logo.svg', import.meta.url);

let simpleConsentManager;

const config = {
    language: lang,
    images: {
        home: {
            source: imageUrl,
            alternative: '',
            width: '80px',
            height: 'auto',
            alignment: 'left'
        },
        settings: {
            source: imageUrl,
            alternative: '',
            width: '80px',
            height: 'auto',
            alignment: 'left'
        }
    },
    translations: {
        en: {
            privacyPolicy: {
                url: privacyPolicy,
                label: 'Privacy policy'
            },
            home: {
                description: 'This site uses cookies necessary for it\'s operation. It also uses third party services (Matomo and Youtube). By allowing these third party services, you accepte the creation and reading of cookies on your browser.'
            },
            settings: {
                services: {
                    matomo: {
                        label: 'Matomo',
                        description: 'Measures our site\'s traffic',
                        url: 'https://matomo.org/faq/general/faq_146/'
                    },
                    youtube: {
                        label: 'Youtube',
                        description: 'Identify visitors from Youtube',
                        url: 'https://www.youtube.com/intl/en_EN/howyoutubeworks/privacy/'
                    }
                }
            }
        },
        fr: {
            privacyPolicy: {
                url: privacyPolicy,
                label: 'Politique de confidentialité'
            },
            home: {
                description: 'Ce site utilise des cookies nécessaires à son bon fonctionnement. Il fait également usage de services tiers (Matomo et YouTube). En autorisant ces services tiers vous acceptez le dépôt et la lecture de cookies sur votre navigateur.'
            },
            settings: {
                services: {
                    matomo: {
                        label: 'Matomo',
                        description: 'Mesure l\'audience de notre site',
                        url: 'https://fr.matomo.org/faq/faq_146/'
                    },
                    youtube: {
                        label: 'Youtube',
                        description: 'Identifie les visiteurs en provenance de Youtube',
                        url: 'https://www.youtube.com/intl/fr_FR/howyoutubeworks/privacy/'
                    }
                }
            }
        }
    },
    services: {
        matomo: {
            callback: (consent) => {
                if (!matomoUrl || !matomoId) {
                    console.error('Missing arguments', { matomoUrl, matomoId });
                    return;
                }

                if (consent) {
                    const _paq = (window as any)._paq = (window as any)._paq || [];
                    _paq.push(['trackPageView']);
                    _paq.push(['enableLinkTracking']);
                    (function () {
                        const u = matomoUrl;
                        _paq.push(['setTrackerUrl', u + 'matomo.php']);
                        _paq.push(['setSiteId', matomoId]);
                        const d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
                        g.async = true;
                        g.src = u + 'matomo.js';
                        s.parentNode.insertBefore(g, s);
                    })();
                }
            },
            image: {
                source: 'https://images.seeklogo.com/logo-png/44/1/matomo-logo-png_seeklogo-443589.png'
            }
        },
        youtube: {
            callback: (consent) => {
                const iframeElements = document.querySelectorAll('[data-service="youtube"]') as NodeListOf<HTMLIFrameElement>;

                if (iframeElements) {
                    if (consent) {
                        iframeElements.forEach((iframeElement) => {
                            iframeElement.src = iframeElement.dataset.src || '';
                            iframeElement.title = iframeElement.dataset.title || '';
                        });
                    } else {
                        iframeElements.forEach((iframeElement) => {
                            iframeElement.src = '';
                            iframeElement.title = '';
                        });
                    }
                }
            },
            image: {
                source: 'https://www.svgrepo.com/show/303198/youtube-icon-logo.svg'
            }
        }
    },
    recordsUrl: '/scm/write'
};

export function initSimpleConsentManager () {
    simpleConsentManager = new SimpleConsentManager(config);
}

export function openSimpleConsentManager () {
    if (!simpleConsentManager) {
        console.error('SimpleConsentManager not found.');
        return;
    }

    simpleConsentManager.open();
}

export function requestConsentSimpleConsentManager (service: string) {
    if (!simpleConsentManager) {
        console.error('SimpleConsentManager not found.');
        return;
    }

    simpleConsentManager.open(service);
}